export const roleService = {
    methods: {
        hasRole(roles) {
            if (this.$keycloak) {
                return this.$keycloak.authenticated && this.$keycloak.hasResourceRole(roles)
            } else {
                return false;
            }
        },

        hasAnyRole() {
            if (this.$keycloak) {
                return this.$keycloak.authenticated && (this.$keycloak.hasAnyRole)
            } else {
                return false;
            }
        },

        hasInternalAttachmentsRole() {
            return this.isHRTransactions() || this.isSalary()
            || this.isLeave() || this.isDraft() || this.isAudit()
            || this.isAdmin() || this.isLead()
            || this.isPayroll() || this.isSpecialist()
        },

        isAdmin() {
           return this.hasRole('hrm-admin')
        },

        isUserAdmin() {
            return this.hasRole('hrm-user-admin')
        },

        isSpecialist() {
            return this.hasRole('hrm-specialist')
        },

        isLead() {
            return this.hasRole('hrm-lead')
        },

        isFfm() {
            return this.hasRole('ffm-reviewer')
        },

        isHRTransactions() {
            return this.hasRole('hrm-transactions')
        },

        isPayroll() {
            return this.hasRole('hrm-payroll')
        },

        isRequester(){
            return this.hasRole('hrm-requester')
        },

        isAudit() {
            return this.hasRole('hrm-audit')
        },

        isLeave() {
            return this.hasRole('hrm-leave')
        },

        isDraft() {
            return this.hasRole('hrm-draft')
        },

        isSalary() {
            return this.hasRole('hrm-salary')
        },

        isCwd() {
            return this.hasRole('hrm-cwd')
        },

        isIcsHrm() {
            return this.hasRole('isc-hrm')
        },

        isCfo() {
            return this.hasRole('ics-cfo')
        }
    }
}